module.exports = __webpack_public_path__ + "static/media/magazineTupp_02_thumb.37b48730.png";